import AppPage from '../../mixins/app-page'

import AppNewsletter from '../app-newsletter'

import ModelsExperience from '../../libs/experience/ModelsExperience'

export default
{
    name: 'page-platform',

    mixins: [
        AppPage
    ],

    components: {
        AppNewsletter
    },

    data() {
        return {
            roadmapItems: [{
                image: 'dev',
                title: 'KEY SDK & GATEWAY Launched',
                content: 'With both KEY SDK and GATEWAY launched to the public, both fronts will see major updates on a monthly basis.'
            }, {
                image: 'users',
                title: 'ARKit Port',
                content: 'To bring PRAX to a larger audience, we will bring Mining Mode to high end iOS devices.'
            }, {
                image: 'ads',
                title: 'Bullet-Proof Localization',
                content: 'We are in the final months of development of our world-scale localization engine. This will be brough to both KEY SDK and GATEWAY soon.'
            }, {
                image: 'wallet',
                title: 'Swiss Relocation',
                content: 'We intent for a physical relocation to Switzerland to ensure our team can operate in peace with defined regulatory guidelines.'
            }, {
                image: 'appless',
                title: 'ARCore Port',
                content: 'Mining Mode will expand beyond iOS and we will allow Android users to join our mission to map the world in 3D.'
            }, {
                image: 'api',
                title: 'Public PRAX Sale',
                content: 'We will launch PRAX with a fully functional, battle-tested network.'
            }]
        }
    },

    mounted() {
        this.$background = document.querySelector('.js-background')
        
        this.setExperience()
        this.setSections()
        
        this.eventHub.$on('application:onEnterFrame', this.onEnterFrame)
        this.eventHub.$on('window:resize', this.onResize)
    },

    destroyed() {
        this.$background.removeChild(this.experience.renderer.domElement)
        this.experience.dispose()
        
        this.eventHub.$off('application:onEnterFrame', this.onEnterFrame)
        this.eventHub.$off('window:resize', this.onResize)
    },
    
    methods:
    {
        setExperience() {
            this.experience = new ModelsExperience()
            this.experience.renderer.domElement.classList.add('p-token__experience')
            this.experience.renderer.domElement.classList.add('u-absolute')
            this.experience.renderer.domElement.classList.add('u-pos-tl')

            this.$background.appendChild(this.experience.renderer.domElement)
        },
        
        setSections() {
            this.sections = {}
            this.sections.items = []
            this.sections.closestItem = null
            this.sections.windowHeight = 600
            
            // Resize
            this.sections.resize = () => {
                this.sections.windowHeight = window.innerHeight
            
                this.sections.items.forEach(item => {
                    const boundings = item.$element.getBoundingClientRect()
                    
                    item.center = boundings.top + this.$root.currScrollTop + boundings.height * 0.5
                })
            }
            
            // Test
            this.sections.test = () => {
                let minDistance = Infinity
                let closestItem = null
                
                this.sections.items.forEach(item => {
                    const distance = Math.abs(item.center - (this.$root.currScrollTop + this.sections.windowHeight * 0.5))
                    
                    if (distance < minDistance) {
                        minDistance = distance
                        
                        closestItem = item
                    }
                })
                
                if (closestItem !== this.sections.closestItem) {
                    this.sections.closestItem = closestItem
                    this.experience.setIndex(this.sections.closestItem.index)
                }
            }
            
            // Create items
            const $items = this.$el.querySelectorAll('.js-section')
            let i = 0
            
            $items.forEach($item => {
                const item = {}
                
                item.$element = $item
                item.center = 0
                item.index = i++
                
                this.sections.items.push(item)
            })
            
            // Trigger resize and test
            this.sections.resize()
            this.sections.test()
        },
        
        onResize() {
            this.sections.resize()
        },
        
        onEnterFrame() {
            this.sections.test()
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-platform/script.js